import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';
import { Box, CircularProgress, Typography } from '@mui/material';
import type React from 'react';
import { useEffect } from 'react';

const AuthBridgePage: React.FC = () => {
  useEffect(() => {
    // MSAL v5 requires calling this bridge function in the popup
    // to securely pass the token back to the main window.
    broadcastResponseToMainFrame().catch(() => {
      // Ignored broadcast failure
    });
  }, []);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
    >
      <CircularProgress />
      <Typography variant="body1" sx={{ mt: 2 }}>
        Authenticating...
      </Typography>
    </Box>
  );
};

export default AuthBridgePage;
